import { useAuthContext } from 'src/auth/useAuthContext';

const useVenueAndMarketplaceConfig = (requiredFeatures) => {
  const { configurations = {} } = useAuthContext().user?.venue ?? {};
  if (!requiredFeatures) return false;
  return requiredFeatures.some(feature => configurations[feature] === true);
};

export default useVenueAndMarketplaceConfig;


export const useFranchiseAndMarketplaceConfig = (requiredFeatures) => {
  const { configurations = {} } = useAuthContext().user?.venue?.franchiseId ?? {};
  if (!requiredFeatures) return false;
  return requiredFeatures.some(feature => configurations[feature] === true);
};

